// (function () {
//   const fixEmptyButton = (btn) => {
//     btn.setAttribute('tabindex', '-1');
//     btn.setAttribute('aria-hidden', 'true');
//     btn.setAttribute('role', 'presentation');
//   };

//   const observer = new MutationObserver(() => {
//     const btn = document.querySelector('.onward-opt-out-link');

//     if (btn) {
//       fixEmptyButton(btn);
//     }
//   });

//   observer.observe(document.documentElement, {
//     childList: true,
//     subtree: true
//   });
// })();


(function () {
  function patchKlaviyoForm(form) {
    if (form.dataset.a11yOnInputFixed) return;
    form.dataset.a11yOnInputFixed = "true";

    // Remove aria-live if needed (optional)
    form.removeAttribute("aria-live");

    // Prevent automatic submission triggered by scripts
    const originalSubmit = form.submit;

    form.submit = function () {
      // Block programmatic auto-submit
      console.warn("Blocked automatic form submission (WCAG 3.2.2)");
      return false;
    };

    // Allow user-initiated submits only
    form.addEventListener(
      "submit",
      function (e) {
        if (!e.isTrusted) {
          e.preventDefault();
        }
      },
      true
    );
  }

  function scan(node) {
    if (!node.querySelectorAll) return;

    node
      .querySelectorAll("form.klaviyo-form")
      .forEach(patchKlaviyoForm);
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach(scan);
    });
  });

  function startKlaviyoObserver() {
    if (!document.body) return;
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    scan(document);
  }

  if (document.body) {
    startKlaviyoObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startKlaviyoObserver);
  }
})();

/**
 * Third-party widget a11y patches (run on idle frame, debounced):
 * - Shopify data-sale / privacy opt-out: hidden checkbox + captcha textareas without labels.
 * - Yotpo Product Reviews (Vue): dropdown labels (--inside / --textual) use
 *   data-testid="dropdown-label-inside" with aria-hidden and/or faded inline color; fix for AT + contrast.
 * - Yotpo SEO reviews pagination: selected page uses blue text on pink bg; rewrite inline styles.
 * - Yotpo review titles: remove empty h3.yotpo-review-title (WAVE "Empty heading").
 * - Yotpo reviews pagination: demote secondary <nav> landmark to role="group".
 * - Yotpo tab chrome siblings (head / bottomline / border): remove from DOM (not tabpanels).
 * - Shopify privacy banner: keep Accept/Decline/Manage as buttons inside alertdialog (never role=tab).
 * - Star ratings: strip role="img" from rating widgets; use visually-hidden text instead.
 * - Zero-size / empty shells (Superfiliate, empty sections, hidden shop icon): aria-hidden.
 * - Visible decorative icons / marquee slides: role=presentation or clear aria-hidden (AccessScan).
 * - Invalid aria-controls (e.g. Onward #onward-modal missing): remove broken references.
 */
(function () {
  function ensureVisuallyHiddenLabel(el, text) {
    if (!el || el.hasAttribute('data-a11y-privacy-optout')) return;
    if (el.labels && el.labels.length > 0) {
      el.setAttribute('data-a11y-privacy-optout', '');
      return;
    }
    var id = el.id;
    if (!id) {
      id =
        'a11y-privacy-field-' +
        (typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID().replace(/-/g, '')
          : String(Date.now()) + Math.random().toString(36).slice(2));
      el.id = id;
    }
    var label = document.createElement('label');
    label.setAttribute('for', id);
    label.className = 'visually-hidden';
    label.textContent = text;
    el.parentNode.insertBefore(label, el);
    el.setAttribute('data-a11y-privacy-optout', '');
  }

  function patchShopifyDataSaleOptOutA11y() {
    ensureVisuallyHiddenLabel(
      document.getElementById('pc--browser-opt-out-checkbox'),
      'Browser opt-out for targeted advertising and sale or sharing of personal data on this device, as described in our privacy policy. This field is managed automatically.'
    );

    document.querySelectorAll('textarea[name="g-recaptcha-response"]').forEach(function (el) {
      ensureVisuallyHiddenLabel(
        el,
        'Google reCAPTCHA verification response; completed automatically when the challenge is solved.'
      );
    });

    document.querySelectorAll('textarea[name="h-captcha-response"]').forEach(function (el) {
      ensureVisuallyHiddenLabel(
        el,
        'hCaptcha verification response; completed automatically when the challenge is solved.'
      );
    });
  }

  function patchYotpoReviewWidgetLabels() {
    document.querySelectorAll('[data-testid="dropdown-label-inside"]').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      if (el.getAttribute('aria-hidden') === 'true') {
        el.removeAttribute('aria-hidden');
      }
      el.style.setProperty('color', '#333333', 'important');
      el.style.setProperty('opacity', '1', 'important');
    });
  }

  // Yotpo SEO reviews pagination: selected page uses blue text on pink bg (1.18:1).
  // Rewrite the inline style so WAVE/auditors see accessible colors, not just CSS overrides.
  function patchYotpoPaginationContrast() {
    document
      .querySelectorAll(
        'a.yotpo-reviews-seo-pagination-item.selected, a.yotpo-pagination-number.selected'
      )
      .forEach(function (el) {
        var color = (el.style.color || '').replace(/\s/g, '').toLowerCase();
        if (color === 'rgb(255,255,255)' || color === '#ffffff' || color === '#fff') return;
        el.style.setProperty('color', '#ffffff', 'important');
        el.style.setProperty('background-color', '#C64285', 'important');
      });
  }

  // Untitled Yotpo reviews render <h3 class="yotpo-review-title"></h3> — WAVE empty heading.
  // Remove empty titles from the DOM (recommended WAVE fix).
  function patchYotpoEmptyReviewTitles() {
    document.querySelectorAll('h3.yotpo-review-title').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) el.remove();
    });
  }

  // Yotpo pagination <nav> is a secondary link group — keep it out of landmark navigation.
  function patchYotpoPaginationLandmark() {
    document
      .querySelectorAll('nav.yotpo-reviews-seo-pagination-container')
      .forEach(function (nav) {
        if (nav.getAttribute('data-a11y-nav-fixed')) return;
        var div = document.createElement('div');
        Array.prototype.forEach.call(nav.attributes, function (attr) {
          div.setAttribute(attr.name, attr.value);
        });
        div.setAttribute('role', 'group');
        div.setAttribute('data-a11y-nav-fixed', '');
        while (nav.firstChild) {
          div.appendChild(nav.firstChild);
        }
        if (nav.parentNode) {
          nav.parentNode.replaceChild(div, nav);
        }
      });
  }

  // Chrome beside #yotpo-seo-reviews-container is not a tab panel (hidden head/bottomline +
  // decorative border). AccessScan still demands role="tabpanel" when these siblings remain
  // in the DOM — remove them (already display:none / decorative on reviews).
  function patchYotpoTabChrome() {
    document
      .querySelectorAll(
        '.yotpo-base-layout > .yotpo-head, .yotpo-base-layout > .yotpo-bottomline-container, .yotpo-base-layout > .yotpo-review-border-smooth'
      )
      .forEach(function (el) {
        el.remove();
      });
  }

  // Keep Yotpo's native tablist ↔ tabpanel pairing intact.
  // Do not retarget the panel to header buttons (that created an orphan tabpanel for AccessScan).
  function patchYotpoReviewsTabAssociation() {
    var panel = document.getElementById('yotpo-seo-reviews-container');
    if (!panel) return;

    // Undo any earlier demotion of Yotpo's tablist
    document
      .querySelectorAll(
        '.ugc-storefront-widgets-tabs-container.yotpo-seo-page-tabs, .yotpo-seo-page-tabs'
      )
      .forEach(function (list) {
        list.removeAttribute('aria-hidden');
        list.setAttribute('role', 'tablist');
        if (!list.getAttribute('aria-label')) {
          list.setAttribute('aria-label', 'Review Types');
        }
      });

    var yotpoTabs = document.querySelectorAll(
      '#yotpo-seo-reviews-tab-siteReviewsTab, #yotpo-seo-reviews-tab-productReviewsTab'
    );
    var activeTab = null;
    Array.prototype.forEach.call(yotpoTabs, function (tab) {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', 'yotpo-seo-reviews-container');
      if (tab.classList.contains('selected') || tab.getAttribute('aria-selected') === 'true') {
        activeTab = tab;
      }
    });
    if (!activeTab && yotpoTabs.length) activeTab = yotpoTabs[0];

    panel.setAttribute('role', 'tabpanel');
    if (activeTab && activeTab.id) {
      panel.setAttribute('aria-labelledby', activeTab.id);
    }
  }

  // Shopify cookie / privacy banner — leave button markup alone.
  // AccessScan mislabels Accept/Decline/Manage as a tablist; do NOT add role="tablist"/"tab".
  // Revert any prior fieldset experiment so Shopify's original dialog actions remain intact.
  function patchShopifyPrivacyBanner() {
    var banner = document.getElementById('shopify-pc__banner');
    if (banner) {
      if (!banner.getAttribute('role')) {
        banner.setAttribute('role', 'alertdialog');
      }
      banner.setAttribute('aria-modal', 'true');
    }

    document.querySelectorAll('fieldset.shopify-pc__banner__btns[data-a11y-btns-fixed]').forEach(function (el) {
      var div = document.createElement('div');
      div.className = el.className;
      Array.prototype.slice.call(el.childNodes).forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === 'LEGEND') return;
        div.appendChild(node);
      });
      if (el.parentNode) {
        el.parentNode.replaceChild(div, el);
      }
    });

    document.querySelectorAll('.shopify-pc__banner__btns').forEach(function (el) {
      el.removeAttribute('role');
      el.removeAttribute('aria-label');
      el.removeAttribute('data-a11y-btns-fixed');
      el.removeAttribute('style');
    });

    ['shopify-pc__banner__btn-manage-prefs', 'shopify-pc__banner__btn-accept', 'shopify-pc__banner__btn-decline'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn) return;
      btn.removeAttribute('aria-label');
      if (btn.getAttribute('role') === 'tab' || btn.getAttribute('role') === 'tablist') {
        btn.removeAttribute('role');
      }
    });
  }

  // Star ratings: AccessScan flags role="img" on non-<img> containers.
  // Keep aria-label on the widget (do NOT inject visible text — Yotpo CSS overrides .visually-hidden).
  function patchStarRatingImgRole() {
    // Remove any previously injected labels that broke the star UI
    document
      .querySelectorAll(
        '.yotpo-star-rating > .visually-hidden, .yotpo-review-star-rating > .visually-hidden, .yotpo-star-rating > span.visually-hidden, .yotpo-review-star-rating > span.visually-hidden'
      )
      .forEach(function (el) {
        var parent = el.parentElement;
        var text = (el.textContent || '').trim();
        if (parent && text && !parent.getAttribute('aria-label')) {
          parent.setAttribute('aria-label', text);
        }
        el.remove();
      });

    document
      .querySelectorAll(
        '.reviews-summary__stars[role="img"], .yotpo-star-rating[role="img"], .yotpo-review-star-rating[role="img"], .yotpo-star-rating, .yotpo-review-star-rating'
      )
      .forEach(function (el) {
        if (el.getAttribute('role') === 'img') {
          el.removeAttribute('role');
        }
        if (!el.getAttribute('aria-label') && el.getAttribute('title')) {
          el.setAttribute('aria-label', el.getAttribute('title'));
        }
        el.querySelectorAll('svg').forEach(decoratePresentationSvg);
      });
  }

  function decoratePresentationSvg(svg) {
    svg.removeAttribute('aria-hidden');
    svg.setAttribute('role', 'presentation');
    svg.setAttribute('focusable', 'false');
  }

  // Visible content must not use aria-hidden (AccessScan).
  // - Decorative stars/icons → role="presentation"
  // - Announcement marquee slides stay on-screen while Slick sets aria-hidden → remove it
  function patchVisibleAriaHiddenConflicts() {
    document
      .querySelectorAll(
        '.reviews-summary__star[aria-hidden="true"], .reviews-summary__bar-label svg[aria-hidden="true"], .reviews-summary__ai-badge svg[aria-hidden="true"], .yotpo-star-rating svg[aria-hidden="true"], .yotpo-review-star-rating svg[aria-hidden="true"], svg.yotpo-star-rating-icon[aria-hidden="true"]'
      )
      .forEach(decoratePresentationSvg);

    document
      .querySelectorAll(
        '.annouceslider .slick-slide[aria-hidden="true"], .announcement-bar .slick-slide[aria-hidden="true"], .announcement-bar-new .slick-slide[aria-hidden="true"], .abouncment-wrap .slick-slide[aria-hidden="true"]'
      )
      .forEach(function (slide) {
        slide.removeAttribute('aria-hidden');
      });
  }

  // Visually empty / zero-size nodes still in the a11y tree confuse screen readers (AccessScan).
  function patchVisuallyHiddenExposure() {
    function hideIfCollapsed(el) {
      if (!el) return;
      var rect = el.getBoundingClientRect();
      var style = window.getComputedStyle(el);
      var empty =
        !(el.textContent || '').trim() &&
        !el.querySelector('img, svg, input, button, a, iframe, video');
      var collapsed =
        rect.height < 2 ||
        (rect.width < 2 && rect.height < 2) ||
        style.display === 'none' ||
        style.visibility === 'hidden';
      if (collapsed || empty) {
        el.setAttribute('aria-hidden', 'true');
      }
    }

    hideIfCollapsed(document.getElementById('_sf-storefront-ProgramWidget'));
    hideIfCollapsed(document.getElementById('shopify-section-subscription-portal-announcement'));

    document.querySelectorAll('.shop-now-icon').forEach(function (el) {
      var wrap = el.querySelector('.shop-now-icon-wrap');
      var wrapHidden = wrap && window.getComputedStyle(wrap).display === 'none';
      var rect = el.getBoundingClientRect();
      var selfHidden = window.getComputedStyle(el).display === 'none';
      if (wrapHidden || selfHidden || rect.height < 2 || rect.width < 2) {
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('aria-hidden');
      }
    });

    document.querySelectorAll('.reviews-summary__divider').forEach(function (el) {
      el.removeAttribute('aria-hidden');
      el.setAttribute('role', 'presentation');
    });
  }

  // Onward (and similar): aria-controls must point to an existing id.
  function patchInvalidAriaControls() {
    document.querySelectorAll('[aria-controls]').forEach(function (el) {
      var ids = (el.getAttribute('aria-controls') || '').trim().split(/\s+/);
      var valid = ids.filter(function (id) {
        return id && document.getElementById(id);
      });
      if (valid.length === 0) {
        el.removeAttribute('aria-controls');
      } else if (valid.length !== ids.length) {
        el.setAttribute('aria-controls', valid.join(' '));
      }
    });
  }

  var scheduled = false;
  function schedulePatch() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      patchShopifyDataSaleOptOutA11y();
      patchYotpoReviewWidgetLabels();
      patchYotpoPaginationContrast();
      patchYotpoEmptyReviewTitles();
      patchYotpoPaginationLandmark();
      patchYotpoTabChrome();
      patchYotpoReviewsTabAssociation();
      patchShopifyPrivacyBanner();
      patchStarRatingImgRole();
      patchVisuallyHiddenExposure();
      patchVisibleAriaHiddenConflicts();
      patchInvalidAriaControls();
    });
  }

  function start() {
    patchShopifyDataSaleOptOutA11y();
    patchYotpoReviewWidgetLabels();
    patchYotpoPaginationContrast();
    patchYotpoEmptyReviewTitles();
    patchYotpoPaginationLandmark();
    patchYotpoTabChrome();
    patchYotpoReviewsTabAssociation();
    patchShopifyPrivacyBanner();
    patchStarRatingImgRole();
    patchVisuallyHiddenExposure();
    patchVisibleAriaHiddenConflicts();
    patchInvalidAriaControls();
    var mo = new MutationObserver(schedulePatch);
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'style', 'role', 'aria-controls', 'aria-labelledby', 'aria-selected'],
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();












// function applyTolstoyLabels() {
//   const previousIcons = document.querySelectorAll('.tolstoy-previous-button svg');
//   const nextIcons = document.querySelectorAll('.tolstoy-next-button svg');

//   previousIcons.forEach(svg => {
//     svg.setAttribute('role', 'img');
//     svg.setAttribute('aria-label', 'previous');
//     svg.removeAttribute('aria-hidden');
//     svg.setAttribute('data-a11y-fixed', 'true'); // prevent reprocessing
//   });

//   nextIcons.forEach(svg => {
//     svg.setAttribute('role', 'img');
//     svg.setAttribute('aria-label', 'next');
//     svg.removeAttribute('aria-hidden');
//     svg.setAttribute('data-a11y-fixed', 'true');
//   });
// }

// // Run once immediately
// applyTolstoyLabels();

// // Watch for dynamically added content
// const observer = new MutationObserver(() => {
//   applyTolstoyLabels();
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });







